import React from 'react';
import { useTheme } from '@/hooks/useTheme';
import { LoginForm } from './LoginForm';

const LoginPage = () => {
  const { theme } = useTheme();

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <div className="md:w-1/2 hidden md:flex items-center justify-center relative overflow-hidden bg-gradient-to-br from-primary/5 to-background">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center opacity-5"></div>
        
        <div className="relative z-10 text-center p-8 max-w-md">
    
          <div className="flex justify-center mb-8">
            <img 
              src="https://ipl-fleet-tracking.s3.ap-south-1.amazonaws.com/src/logo.png" 
              alt="IPL Fleet Tracking Logo" 
              className="h-40 object-contain mx-auto"
            />
          </div>
          
          <h1 className="text-4xl font-bold text-foreground mb-4">
            IPL VLTS
          </h1>
          
          <p className="text-lg text-foreground/80 mb-2">
           VLTS management solution
          </p>
          
          <p className="text-base text-foreground/60">
            Track, manage, and optimize your VLTS operations with real-time insights and analytics.
          </p>
          
          <div className="mt-8 flex justify-center space-x-4">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-2 border border-primary/20">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <span className="text-sm text-foreground/70">Secure</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-2 border border-primary/20">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <span className="text-sm text-foreground/70">Real-time</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-2 border border-primary/20">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <span className="text-sm text-foreground/70">Analytics</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="md:w-1/2 w-full flex items-center justify-center p-6 bg-background">
        <div className="w-full max-w-md">
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;